import { Skeleton } from '@mui/material'
import { Card, ValueSunburstWithTable, ValueSunburstWithTableLoading } from 'components/core-v2'

import { useFilteredGetByTenantAccountDashboardQuery } from '../../utils/useFilteredNotes'
import { formatData } from './formatData'

export const StrategySunburstChart = () => {
  const { data, isFetching, isLoading } = useFilteredGetByTenantAccountDashboardQuery()

  if (isLoading || isFetching) {
    return (
      <Card.Wrapper>
        <Card.Header>
          <Skeleton height="15px" variant="rectangular" width="160px" />
        </Card.Header>
        <ValueSunburstWithTableLoading />
      </Card.Wrapper>
    )
  }

  const { strategies } = data
  const title = `${strategies.length} ${strategies.length === 1 ? 'Strategy' : 'Strategies'}`

  const formattedData = formatData(strategies)

  return (
    <Card.Wrapper>
      <Card.Header title={title} />
      <ValueSunburstWithTable data={formattedData} seriesName="Strategies" />
    </Card.Wrapper>
  )
}
